import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";

const API = `${config.API_BASE_URL}/api/admin/feedback`;

const AdminFeedback = () => {

  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  // ==========================
  // LOAD FEEDBACK
  // ==========================
  const loadFeedback = async () => {

    try {

      const res = await axios.get(API, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (res.data.success) {
        setFeedbacks(res.data.data);
      }

    } catch (err) {
      console.error(err);
      alert("Unable to load feedback.");
    }

    setLoading(false);

  };

  useEffect(() => {
    loadFeedback();
  }, []);

  // ==========================
  // APPROVE
  // ==========================
  const approveFeedback = async (id) => {

    try {

      await axios.put(
        `${API}/${id}/approve`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadFeedback();

    } catch (err) {
      console.error(err);
    }

  };

  // ==========================
  // FEATURE
  // ==========================
  const featureFeedback = async (id) => {

    try {

      await axios.put(
        `${API}/${id}/feature`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadFeedback();

    } catch (err) {
      console.error(err);
    }

  };

  // ==========================
  // DELETE
  // ==========================
  const deleteFeedback = async (id) => {

    if (!window.confirm("Delete this feedback?"))
      return;

    try {

      await axios.delete(
        `${API}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadFeedback();

    } catch (err) {
      console.error(err);
    }

  };

  // ==========================
  // UI
  // ==========================
  return (

    <div style={styles.container}>

      <h2>Customer Feedback</h2>

      {loading ? (

        <p>Loading...</p>

      ) : (

        <table style={styles.table}>

          <thead>

            <tr>

              <th>ID</th>
              <th>User</th>
              <th>Rating</th>
              <th>Feedback</th>
              <th>Status</th>
              <th>Featured</th>
              <th>Date</th>
              <th>Action</th>

            </tr>

          </thead>

          <tbody>

            {feedbacks.map((f) => (

              <tr key={f.feedbackid}>

                <td>{f.feedbackid}</td>

                <td>{f.userid}</td>

                <td>

                  {"⭐".repeat(f.rating)}

                </td>

                <td style={{maxWidth:350}}>

                  {f.message}

                </td>

                <td>

                  {f.isapproved
                    ? "✅ Approved"
                    : "⏳ Pending"}

                </td>

                <td>

                  {f.isfeatured
                    ? "🌟 Yes"
                    : "No"}

                </td>

                <td>

                  {new Date(
                    f.createdat
                  ).toLocaleDateString()}

                </td>

                <td>

                  <button
                    style={styles.green}
                    onClick={() =>
                      approveFeedback(
                        f.feedbackid
                      )
                    }
                  >
                    {f.isapproved
                      ? "Unapprove"
                      : "Approve"}
                  </button>

                  <button
                    style={styles.orange}
                    onClick={() =>
                      featureFeedback(
                        f.feedbackid
                      )
                    }
                  >
                    {f.isfeatured
                      ? "Remove"
                      : "Feature"}
                  </button>

                  <button
                    style={styles.red}
                    onClick={() =>
                      deleteFeedback(
                        f.feedbackid
                      )
                    }
                  >
                    Delete
                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      )}

    </div>

  );

};

export default AdminFeedback;

const styles = {

  container: {
    padding: 25
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  green: {
    background: "#28a745",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    margin: 3,
    cursor: "pointer",
    borderRadius: 5
  },

  orange: {
    background: "#ff9800",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    margin: 3,
    cursor: "pointer",
    borderRadius: 5
  },

  red: {
    background: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    margin: 3,
    cursor: "pointer",
    borderRadius: 5
  }

};